const initialStateHome = {
  homeDisplay:"Market & News",
  contactUs:false,
  pageTyped:false,
  clientSelected:"Emma Thompson",
  }
  
const initialStateSidebar = {
    sidebarLeftExpanded:true,
    sidebarOpen: false,
    sidebarRightContent: "watchlist",
    showInfoTag: true,
    showSidebarRight:false,
    infoContent:"",
    sidebarLeftMenuOpen:true,
    settingsLoaded:false,
    navLinksSelected:[]
  };

const initialStateSearch = {
  searchClick: false,
  searchTickerHistory:[],
  addPeers:false,
    }


const initialStateChats = {
  chats:{},
  chatId: null,
  user: {},
  unreadChatCount:0,
  unreadChatIds:{},
  chatting:false,
  unreadRecentChat:{},
  chatHomeNotification:true
}

const initialStateWatchlist={
  loadingWatchlist:false,
  createWatchlist:false,
  watchlistMenu:false,
  watchlistData:{},
  watchlistSelected:undefined,
};

const initialStateNotes = {
  loaded:false,
  saved:false,
  names:[],
  nameSel:"",
  data:{},
  dataSel:"",}

export {
  initialStateChats,
  initialStateHome,
  initialStateNotes,
  initialStateSearch,
  initialStateSidebar,
  initialStateWatchlist,
};